<template>
    <div>
        <b-modal id="modify-bin-entity" ref="modal" :title="titlePopup" size="sm" no-close-on-backdrop no-close-on-esc
            hide-footer modal-class="hide-footer" :hide-header-close="loading" @hidden="onHidden">
            <b-form @submit.stop.prevent="onSubmit()" @reset.stop.prevent="onHidden">
                <div class="row custom-model-form">
                    <div class="col-md-6">
                        <b-form-group id="bin-score-min" label="Minimum Range" label-for="Min">
                            <b-form-input id="bin-score-min-close-input" v-model="formData.min" v-validate="{
            required: true,
            regex: /^([0-9]*)$/,
            min: 1,
            max: 3,
        }" type="text" autocomplete="no" placeholder="Minimum Range" name="Min" :class="{
            'is-invalid': errors.has('close'),
        }"></b-form-input>
                        </b-form-group>
                    </div>

                    <div class="col-md-6">
                        <b-form-group id="bin-score-max" label="Maximum Score" label-for="Maximum">
                            <b-form-input id="bin-score-max-input" v-model="formData.max" v-validate="{
            required: true,
            regex: /^([0-9]*)$/,
            min: 1,
            max: 3,
        }" type="text" autocomplete="no" placeholder="Maximum Range" name="Naximum" :class="{
            'is-invalid': errors.has('far'),
        }"></b-form-input>
                        </b-form-group>
                    </div>

                    <!-- <div class="col-md-12">
                        <b-form-group
                            id="risk-factor-override"
                            label="Override To"
                            label-for="Override To"
                        >
                            <b-form-select
                                id="risk-factor-override-input"
                                v-model="formData.overRideTo"
                                class="form-control"
                                :options="overrideToOptions"
                                name="overrideTo"
                                :class="{
                                    'is-invalid': errors.has('overrideTo'),
                                }"
                            ></b-form-select>
                        </b-form-group>
                    </div> -->
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button btn-label="Update" btn-type="submit" btn-variant="primary"
                        :class="loading ? 'disabled' : ''" @click="onSubmit()"></base-button>
                    <base-button btn-label="Cancel" btn-type="reset" btn-variant="link"></base-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import resource from '@/api/resource'
const sarApi = new resource('configurations/ProximityDistanceScore/?type=Entity')
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        title: {
            type: String,
            default: null,
        },
        loadWordDistanceScore: {
            type: Function,
            default: () => { },
        },
    },
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            formData: this.initializeFormData(),

            high: '',
            low: '',
            medium: '',

            overrideToOptions: [
                { value: null, text: 'Select Override To', disabled: true },
                { value: '', text: 'N/A' },
                { value: 'high', text: 'High Risk' },
                { value: 'medium', text: 'Medium Risk' },
                { value: 'low', text: 'Low Risk' },
                { value: 'sanction', text: 'Sanction Risk' },
            ],
        }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'loading',
            'selectedItem',
            'dataSegmentId',
            'hidePopup',
        ]),
        titlePopup() {

            if (this.selectedItem) {
                var parsedobj = JSON.parse(JSON.stringify(this.selectedItem))
                console.log('a', parsedobj.id)

                return parsedobj.id == 1 ? "Close word distances" : parsedobj.id == 2 ? " Medium word distances" : parsedobj.id == 3 ? " Far word distances" : 'word distances'
            }
            else {
                return "word distances"
            }


            // if(parsedobj.id == 1)
            // {
            //     return 'close word distances'
            // }



            // if(parsedobj.id ==3)
            // {
            //     return 'far word distances'
            // }
        }, // End of titlePopup() method
        // titlePopup() {
        //     return 'Word distances'
        // }, // End of titlePopup() method

        buttonLabel() {
            return 'Update'
        },
        highLabel() {
            return this.formData.factor === 'Assets Under Management' ||
                this.formData.factor === 'Suspicious Activity Reports'
                ? 'Sanction'
                : 'High'
        },
        highPlaceholder() {
            return this.formData.factor === 'Assets Under Management' ||
                this.formData.factor === 'Suspicious Activity Reports'
                ? 'Sanction Scale'
                : 'High Scale'
        },
        lowLabel() {
            return this.formData.factor === 'Assets Under Management' ||
                this.formData.factor === 'Suspicious Activity Reports'
                ? 'Medium'
                : 'Low'
        },
        lowPlaceholder() {
            return this.formData.factor === 'Assets Under Management' ||
                this.formData.factor === 'Suspicious Activity Reports'
                ? 'Medium Scale'
                : 'Low Scale'
        },
        mediumLabel() {
            return this.formData.factor === 'Assets Under Management' ||
                this.formData.factor === 'Suspicious Activity Reports'
                ? 'High'
                : 'Medium'
        },
        mediumPlaceholder() {
            return this.formData.factor === 'Assets Under Management' ||
                this.formData.factor === 'Suspicious Activity Reports'
                ? 'High Scale'
                : 'Medium Scale'
        },
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        dataSegmentId(value) {
            console.log(value)
        },
        /**
         * Handle when the selected has been updated
         *
         * @return {void}
         */
        async selectedItem(value) {
            console.log('the watch value', value)
            if (value !== null && value !== undefined) {
                let minMaxStr = value.score.split(" ")[0];
                this.formData.min = minMaxStr.split("-")[0];
                this.formData.max = minMaxStr.split("-")[1];
                // if (this.dataSegmentId) {
                //     let { data } = await sarApi.list({
                //         dataSegmentId: this.dataSegmentId,
                //     })

                //     console.log('close', data.data[0].close[0])

                //     if (value.id == 1) {
                //         this.formData.min = data.data[0].close[0]
                //         this.formData.max = data.data[0].close[1]
                //     }
                //     if (value.id == 2) {
                //         this.formData.min = data.data[0].medium[0]
                //         this.formData.max = data.data[0].medium[1]
                //     }
                //     if (value.id == 3) {
                //         this.formData.min = data.data[0].far[0]
                //         this.formData.max = data.data[0].far[1]
                //     }
                // }

                Object.assign(this.formData, JSON.parse(JSON.stringify(value)))
            } else {
                this.onHidden()
            }
        },
        /**
         * Handle when the popup hide
         *
         * @return {void}
         */
        hidePopup(value) {
            if (value) {
                this.onHidden()
            }
        },
    }, // End of Component > watch
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        initializeFormData() {
            return {
                _id: null,
                dataSegmentId: '',
                id: '',
                min: '',
                score: '',
                max: '',
            }
        }, // End of initializeFormData() method
        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            this.$store.commit('onSubmit', null)
            Object.assign(this.formData, this.initializeFormData())
            this.$validator.reset()
            this.$refs.modal.hide()
        }, // End of onHidden() method

        async getScoreDetails(event) {
            try {
                // const ScoreApi = new resource(
                //     `configurations/ProximityScore?type=Standard/AM`
                // )
                const CategoriApi = new resource(
                    `configurations/CategorieAdverse`
                )

                this.dataSegmentId
                // let data = await ScoreApi.get(this.dataSegmentId)

                // this.data1 = data.data.data
                let dataCategorie = await CategoriApi.get(this.dataSegmentId)

                this.Adverse_Check_items =
                    dataCategorie.data.data[0].AllCategorie

                this.Adverse_Check_items_most_used =
                    dataCategorie.data.data[0].MostCategorie
            } catch {
                console.log(error)
                this.$store.commit('setError', error)
                this.$store.commit('setLoading', false)
            }

            // this.tier = dataSegment.data.data.tier
            // this.subscription = dataSegment.data.data.subscription
            // if (this.subscription == 'unpaid') {
            //     this.counter = 0
            // } else {
            //     this.counter = dataSegment.data.data.counter
            // }

            // this.$store.commit('setDataSegmentList', this.dataSegmentList)
        },
        /**
         * Handle when the modal is canceled
         *
         * @return {void}
         */
        async onSubmit() {
            const result = await this.$validator.validateAll()
            console.log('submit', this.formData)
            if (result) {
                try {
                    this.$store.commit('setLoading', true)
                    let params = {
                        dataSegmentId: this.dataSegmentId,
                        type: 'Entity',
                        id: this.formData.id,
                        min: parseInt(this.formData.min),
                        max: parseInt(this.formData.max),
                    }
                    // cancel review process for this alert
                    let resourceApi = new resource(
                        'configurations/ProximityDistanceScore'
                    )
                    let { data } = await resourceApi.update(
                        params.dataSegmentId,
                        params
                    )
                    await this.loadWordDistanceScore()
                    console.log(data)
                    if (data) {
                        //          await this.$store.dispatch('onSubmit', this.formData)
                        this.$store.commit('setLoading', false)
                        //   await this.$store.dispatch('onSubmit', this.formData)
                        // await this.$store.commit('setAlertRecord', data.data)
                        // this.$store.commit('setRefreshProfile', true)

                        this.$store.commit('setSuccess', data.message)
                        this.$refs.modal.hide()
                    }


                    //   await this.$store.dispatch('onSubmit', this.formData)
                } catch (error) {
                    console.log(error, 'There is an error on submit')
                    this.$store.commit('setLoading', false)
                    this.$refs.modal.hide()
                    this.$store.commit('setError', error)
                }
            }
        }, // End of onSubmit() method
    }, // End of Component > methods
}
</script>